import moment from "moment";
import { updateRequest } from "../../../constant/common";

export const inputAmountStyle = {
  height: "40px",
  borderRadius: "5px",
  paddingLeft: "20px",
};
export const inputStyle = {
  ...inputAmountStyle,
  width: '85%'
};
export const headerColumnStyle = { padding: "0 10px", width: "15%" };
export const poItemListingColumns = [
  { label: "Select Line", hoverDescription: "Select Line Item", colKey: 'isChecked', type: 'checkbox', disabled: false },
  { label: "Item ", hoverDescription: "Item", colKey: 'itemNo', type: 'input', disabled: true },
  { label: "Material", hoverDescription: "Material", colKey: 'materialNo', type: 'input', disabled: true },
  { label: "Material Short text", hoverDescription: "Material Short text", colKey: 'materialShortText', type: 'input', disabled: true },
  { label: "Mateial Group", hoverDescription: "Mateial Group", colKey: 'matGrp', type: 'input', disabled: true },
  { label: "Quantity", hoverDescription: "Quantity in unit of entry", colKey: 'quantity', type: 'input', disabled: false },
  { label: "Unit", hoverDescription: "Unit of entry", colKey: 'unit', type: 'input', disabled: true },
  // { label: "Profit Center ", hoverDescription: "Profit Center", colKey: 'profitCtr', type: 'input', disabled: true },
  { label: "Plant ", hoverDescription: "Status", colKey: 'plant', type: 'input', disabled: true },
  // { label: "Purchase Order", hoverDescription: "Purchase Order", colKey: 'poNumber', type: 'input', disabled: true },
  { label: "Ibd", hoverDescription: "Ibd", colKey: 'ibd', type: 'input', disabled: true },
  { label: "Ibd Item", hoverDescription: "Ibd Item", colKey: 'ibdItem', type: 'input', disabled: true },
  { label: "Serial Number ", hoverDescription: "Serial Number", colKey: 'serialItem', type: 'dialoge', disabled: true },

];

export const initialFilter = {
  poNumber: "",
  plant: [],
  materialNo: "",
  dateHigh: "",
  dateLow: "",
  docNo: "",
  year: "",
  uuid: ""
}

const formatDate = (date) => {
  if (!date || !moment(date).isValid()) return '';
  return moment(date).format("YYYYMMDD");
};


export const createReqObject = (rows = [], header = {}, fileData, grntype, plant, globalFilter, userData) => {
  // only include checked items in case of create screen
  const filteredRows = grntype?.value === "101"
    ? rows.filter(row => row.isChecked)
    : rows;
  const itemsList = filteredRows?.map((row) => {
    const item = updateRequest(row);
    return {
      itemNo: item?.itemNo || "",
      shortText: item?.materialShortText || "",
      unit: item?.unit || "",
      storeLoc: "SLOC", //Static
      profitCtr: item?.profitCtr || "",
      mvtType: header?.mvtType?.value || "101",
      stockType: "",
      plant: item?.plant || "",
      material: item?.materialNo || "",
      matGrp: item?.matGrp || "",
      quantity: item?.quantity || "",
      deliveryIndicator: "",
      confNo: item?.confNo || "",
      ibdItem: item?.ibdItem || "",
      ibd: item?.ibd || "",
      serialItem: item?.updatedSerialItems
        ? (item?.updatedSerialItems?.map(serial => ({
          itemNo: serial?.itemNo || "",
          serialNo: serial?.serialNo || ""
        })) || [])
        : (item?.serialItem?.map(serial => ({
          itemNo: serial?.itemNo || "",
          serialNo: serial?.serialNo || ""
        })) || [])
    };
  });

  return {
    grn: {
      header: {
        poNumber: String(header?.poNumber || ""),
        docDate: formatDate(header?.docDate) || "",
        postingDate: formatDate(header?.postingDate),
        deliveryNote: header?.deliveryNote || "",
        vendor: header?.vendor || "",
        receivingVendor: header?.receivingVendor || "",
        docNo: header?.docNo || "",
        year: header?.year || "",
        mvtType: header?.mvtType?.value || "101",
        attachment: fileData?.attachment || "",
        attachmentName: fileData?.fileName || "",
        attachmentExtension: fileData?.fileExtension || "",
        plant: Array.isArray(plant) ? plant.map(p => p.value).filter(Boolean) : [],
        actionInd: grntype?.value === '101' ? 'C' : grntype?.value === 'pendingScreen' ? 'A' : '',
        uuid: globalFilter?.uuid || "",
        creator: grntype?.value === 'pendingScreen' ? header?.creator : (userData?.employeeId || ""),
        approver: header?.approver || '',
        billOfLading: header?.billOfLading || '',
        headerText: header?.headerText || ''
      },
      items: itemsList
    }
  };
};


export const createReqObjForRev = (rows = [], header = {}, fileData, grntype, docNo) => {

  const itemsList = rows.map((row) => {
    const item = updateRequest(row);
    return {
      itemNo: item?.itemNo || "",
    };
  });

  return {
    grn: {
      header: {
        docNo: docNo || "",
        year: header?.year || "",
        mvtType: header?.mvtType?.value || "",
        attachment: fileData?.attachment || "",
        attachmentName: fileData?.fileName || "",
        attachmentExtension: fileData?.fileExtension || "",
        actionInd: (grntype?.value === '102') ? 'X' : grntype?.value === 'pendingScreen' ? 'D' : '',
        poNumber: header?.poNumber || "",
        uuid: header?.uuid || "",
        creator: header?.creator || "",
        approver: header?.approver || '',
        billOfLading: header?.billOfLading,
        headerText: header?.headerText,
      },
      items: itemsList
    }
  };
};


export const grnTypes = [
  {
    id: 0,
    label: "Create GRN",
    value: "101"
  },
  {
    id: 2,
    label: "List/Cancel GRN",
    value: "102"
  },
  {
    id: 3,
    label: "Pending GRN",
    value: "pendingScreen"
  }
];

export const grnRoleAccessMap = {
  C: ["101", "102", "pendingScreen"],              // Creator → Create + List/Cancel
  U: ["101", "102"],              // Updater → same as creator
  A: ["102", "pendingScreen"],    // Approver → List/Cancel + Pending
};

export const getGrnDropdownByRole = (roles = []) => {
  let allowedValues = new Set();

  roles.forEach(role => {
    (grnRoleAccessMap[role] || []).forEach(v => allowedValues.add(v));
  });

  return grnTypes.filter(item => allowedValues.has(item.value));
};

export const hardcodeDropdown = {
  mvtType: [
    { id: 0, label: '101', value: '101' },
    { id: 1, label: '102', value: '102' }
  ],
  docType: [
    { id: 0, label: 'Digital Serialized-ZDIG', value: 'ZDIG' },
    { id: 1, label: 'Domestic PO-ZDOM', value: 'ZDOM' },
    { id: 2, label: 'Free Of Cost PO-ZFOC', value: 'ZFOC' },
    { id: 3, label: 'Infrastructure-ZINF', value: 'ZINF' },
    { id: 4, label: 'MARKETING PO-ZMRK', value: 'ZMRK' },
    { id: 5, label: 'Domestic PO(PAK)', value: 'ZPAK' },
    { id: 6, label: 'Service PO-ZSER', value: 'ZSER' },

  ]
};

export const grnModule = 'grn';

